var render = function render(){var _vm=this,_c=_vm._self._c;return _c('blw-hero',{attrs:{"header":"No cosigner application found","text":"Check your email for a cosigner invitation and click the link!"}})
}
var staticRenderFns = []

export { render, staticRenderFns }